"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplicationActionBar = void 0;

var _react = _interopRequireDefault(require("react"));

var ApplicationActionBar = function ApplicationActionBar(_ref) {
  var items = _ref.items,
      nodeRef = _ref.nodeRef,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "ApplicationActionBar nav navbar-nav navbar-right ".concat(className),
    ref: nodeRef
  }, items && items.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      role: "presentation",
      className: "navigationItem"
    }, item);
  }));
};

exports.ApplicationActionBar = ApplicationActionBar;